/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MstCalendarCenterSupplier
 */
export interface MstCalendarCenterSupplier {
    /**
     * 
     * @type {boolean}
     * @memberof MstCalendarCenterSupplier
     */
    deleteFlg: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof MstCalendarCenterSupplier
     */
    insertDatetime: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MstCalendarCenterSupplier
     */
    insertUser: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MstCalendarCenterSupplier
     */
    updateDatetime: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MstCalendarCenterSupplier
     */
    updateUser: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MstCalendarCenterSupplier
     */
    deleteDatetime: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MstCalendarCenterSupplier
     */
    deleteUser: string | null;
    /**
     * 
     * @type {number}
     * @memberof MstCalendarCenterSupplier
     */
    companyId: number | null;
    /**
     * 
     * @type {string}
     * @memberof MstCalendarCenterSupplier
     */
    orgCenterId: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstCalendarCenterSupplier
     */
    orgSupplierId: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MstCalendarCenterSupplier
     */
    calendarDate: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCalendarCenterSupplier
     */
    enableSupplierShipday: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCalendarCenterSupplier
     */
    enableOrderday: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof MstCalendarCenterSupplier
     */
    arrivalRatio: number | null;
    /**
     * 
     * @type {string}
     * @memberof MstCalendarCenterSupplier
     */
    remarks: string | null;
}

/**
 * Check if a given object implements the MstCalendarCenterSupplier interface.
 */
export function instanceOfMstCalendarCenterSupplier(value: object): value is MstCalendarCenterSupplier {
    if (!('deleteFlg' in value) || value['deleteFlg'] === undefined) return false;
    if (!('insertDatetime' in value) || value['insertDatetime'] === undefined) return false;
    if (!('insertUser' in value) || value['insertUser'] === undefined) return false;
    if (!('updateDatetime' in value) || value['updateDatetime'] === undefined) return false;
    if (!('updateUser' in value) || value['updateUser'] === undefined) return false;
    if (!('deleteDatetime' in value) || value['deleteDatetime'] === undefined) return false;
    if (!('deleteUser' in value) || value['deleteUser'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('orgCenterId' in value) || value['orgCenterId'] === undefined) return false;
    if (!('orgSupplierId' in value) || value['orgSupplierId'] === undefined) return false;
    if (!('calendarDate' in value) || value['calendarDate'] === undefined) return false;
    if (!('enableSupplierShipday' in value) || value['enableSupplierShipday'] === undefined) return false;
    if (!('enableOrderday' in value) || value['enableOrderday'] === undefined) return false;
    if (!('arrivalRatio' in value) || value['arrivalRatio'] === undefined) return false;
    if (!('remarks' in value) || value['remarks'] === undefined) return false;
    return true;
}

export function MstCalendarCenterSupplierFromJSON(json: any): MstCalendarCenterSupplier {
    return MstCalendarCenterSupplierFromJSONTyped(json, false);
}

export function MstCalendarCenterSupplierFromJSONTyped(json: any, ignoreDiscriminator: boolean): MstCalendarCenterSupplier {
    if (json == null) {
        return json;
    }
    return {
        
        'deleteFlg': json['delete_flg'],
        'insertDatetime': (json['insert_datetime'] == null ? null : new Date(json['insert_datetime'])),
        'insertUser': json['insert_user'],
        'updateDatetime': (json['update_datetime'] == null ? null : new Date(json['update_datetime'])),
        'updateUser': json['update_user'],
        'deleteDatetime': (json['delete_datetime'] == null ? null : new Date(json['delete_datetime'])),
        'deleteUser': json['delete_user'],
        'companyId': json['company_id'],
        'orgCenterId': json['org_center_id'],
        'orgSupplierId': json['org_supplier_id'],
        'calendarDate': (json['calendar_date'] == null ? null : new Date(json['calendar_date'])),
        'enableSupplierShipday': json['enable_supplier_shipday'],
        'enableOrderday': json['enable_orderday'],
        'arrivalRatio': json['arrival_ratio'],
        'remarks': json['remarks'],
    };
}

export function MstCalendarCenterSupplierToJSON(json: any): MstCalendarCenterSupplier {
    return MstCalendarCenterSupplierToJSONTyped(json, false);
}

export function MstCalendarCenterSupplierToJSONTyped(value?: MstCalendarCenterSupplier | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'delete_flg': value['deleteFlg'],
        'insert_datetime': value['insertDatetime'] == null ? value['insertDatetime'] : value['insertDatetime'].toISOString(),
        'insert_user': value['insertUser'],
        'update_datetime': value['updateDatetime'] == null ? value['updateDatetime'] : value['updateDatetime'].toISOString(),
        'update_user': value['updateUser'],
        'delete_datetime': value['deleteDatetime'] == null ? value['deleteDatetime'] : value['deleteDatetime'].toISOString(),
        'delete_user': value['deleteUser'],
        'company_id': value['companyId'],
        'org_center_id': value['orgCenterId'],
        'org_supplier_id': value['orgSupplierId'],
        'calendar_date': value['calendarDate'] == null ? value['calendarDate'] : value['calendarDate'].toISOString().substring(0,10),
        'enable_supplier_shipday': value['enableSupplierShipday'],
        'enable_orderday': value['enableOrderday'],
        'arrival_ratio': value['arrivalRatio'],
        'remarks': value['remarks'],
    };
}

